import React, { useState, useEffect } from 'react'
import { createClient } from '@supabase/supabase-js'
import './EmailVerification.css'

// Supabase配置
const supabaseUrl = 'https://ieumcctsndtnqarvqxwq.supabase.co'
const supabaseKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlldW1jY3RzbmR0bnFhcnZxeHdxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUwMzA0NDksImV4cCI6MjA3MDYwNjQ0OX0.fgNh8aStmxm9pzNjlzO5G0bhOs0hLSqiIHXW9eqENoo'

const supabase = createClient(supabaseUrl, supabaseKey)

const EmailVerification = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState('')

  // 处理邮箱验证
  const handleEmailConfirmation = async () => {
    setIsLoading(true)
    setError('')

    try {
      // 获取URL参数
      const urlParams = new URLSearchParams(window.location.search)
      const accessToken = urlParams.get('access_token')
      const refreshToken = urlParams.get('refresh_token')
      const type = urlParams.get('type')

      console.log('URL参数:', { accessToken, refreshToken, type })

      if (accessToken && refreshToken) {
        // 设置用户会话
        const { data, error } = await supabase.auth.setSession({
          access_token: accessToken,
          refresh_token: refreshToken,
        })

        if (error) {
          throw error
        }

        console.log('会话设置成功:', data)
      }
    } catch (error) {
      console.error('验证失败:', error)
      setError('验证过程中出现错误，请稍后重试。')
    } finally {
      setIsLoading(false)
    }
  }

  // 页面加载时处理验证
  useEffect(() => {
    handleEmailConfirmation()
  }, [])

  return (
    <div className="email-verification-container">
      <div className="email-verification-box">
        <div className="success-icon">✓</div>

        <h1 className="title">邮箱验证成功！</h1>
        <p className="subtitle">您的账户已成功激活</p>

        <div className="message">
          感谢您注册
          EaseStella！您的邮箱地址已成功验证，现在可以开始使用我们的服务了。
        </div>

        <div className="steps">
          <h3>接下来您可以：</h3>
          <div className="step">
            <div className="step-number">1</div>
            <div>返回 EaseStella 应用</div>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <div>使用您的邮箱和密码登录</div>
          </div>
          <div className="step">
            <div className="step-number">3</div>
            <div>开始享受我们的服务</div>
          </div>
        </div>

        {isLoading && (
          <div className="loading">
            <div className="spinner"></div>
            <p>正在处理验证...</p>
          </div>
        )}

        {error && <div className="error-message">{error}</div>}

        <div className="footer">
          <p>如果您在验证过程中遇到任何问题，请联系我们的客服团队。</p>
          <p>© 2024 EaseStella. All rights reserved.</p>
        </div>
      </div>
    </div>
  )
}

export default EmailVerification
